<template>
  <div>
    <h3 class="mb-5">Messaging & Highlight</h3>
    <div class="h4 mb-5">
      呈現於Product Sub Category Page (Product Overview)
      置頂Banner區，可自行添加Banner數量。
    </div>

    <!-- items -->
    <PageCollapse v-for="(item, i) in itemList" :key="i">
      <template v-slot:head>
        <h3 class="mr-auto">Banner {{ i + 1 }}</h3>
      </template>
      <template v-slot:actions>
        <div class="ml-auto">
          <button class="btn square mr-10px" @click="deleteItem(item)">
            <v-icon class="ink-02-medium--text">delete</v-icon>
          </button>
          <button class="btn square mr-10px" @click="downItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
          </button>
          <button class="btn square" @click="upItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <!-- Slogan -->
        <label class="form-item d-flex pb-3">
          <h4 class="w-180px mt-5">Slogan</h4>
          <div class="flex-grow-1 mt-3">
            <div class="form-input-group">
              <input
                type="text"
                placeholder="請輸入 Slogan"
                v-model="item.slogan"
              />
            </div>
            <div class="h5 ink-02-medium--text text-right mt-1">0/10</div>
          </div>
        </label>

        <!-- img uploader -->
        <div class="d-flex px-5 pt-5 mb-8">
          <div class="w-180px">
            <h4 class="mb-10px">Visual</h4>
            <div class="h5 ink-02-medium--text">
              建議尺寸：999px * 999px <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <ImgUploader></ImgUploader>
          </div>
        </div>
      </template>
    </PageCollapse>

    <!-- 添加Company Culture -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加Banner</span>
      </button>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';
import PageCollapse from '@/components/PageCollapse.vue';

export default {
  components: {
    ImgUploader,
    PageCollapse,
  },
  data: () => ({
    itemList: [
      {
        id: '001',
        slogan: 'item1',
        visual: '',
      },
      {
        id: '002',
        slogan: 'item2',
        visual: '',
      },
      {
        id: '003',
        slogan: 'item3',
        visual: '',
      },
    ],
  }),
  methods: {
    addItem() {
      const template = {
        id: Date.now(),
        slogan: `item ${Date.now()}`,
        description: '',
        visual: '',
      };
      this.itemList.push(template);
    },
    deleteItem(item) {
      const index = this.itemList.map((i) => i.id).indexOf(item.id);
      this.itemList.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.itemList.length - 1) {
        this.itemList.splice(i, 1);
        this.itemList.unshift(item);
        return;
      }
      // item become next index
      this.itemList.splice(i, 1);
      this.itemList.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.itemList.splice(i, 1);
        this.itemList.push(item);
        return;
      }
      // item become previous index
      this.itemList.splice(i, 1);
      this.itemList.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
